import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { Box, Divider } from '@mui/material';
import Tooltip from '@src/components/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { MINIMUM_VOICE_REVENUE_WITHDRAWAL_AMOUNT } from '@src/constants/withdrawal';
import sanitizeHtml from 'sanitize-html';
import { getPriceText } from '@src/services/payment';

const TaxDeduction = ({
  amountToWithdraw,
  taxDeduction,
  amountReceivedAfterTax,
  isShowTaxDeduction,
  isError,
  helperText,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const renderUnit = (colorValue) => (
    <Typography
      variant="body-14-medium"
      color={colorValue}
      sx={{
        textDecoration: 'underline',
      }}
    >
      đ
    </Typography>
  );

  const renderItem = ({
    label,
    value,
    tooltip,
    colorLabel = COLOR.label2[64],
    colorValue = COLOR.label2[64],
    isDeduction,
  }) => (
    <Box className="tax-deduction-item">
      <Box className="tax-deduction-item-label">
        <Typography variant="body-14-regular" color={colorLabel}>
          {label}
        </Typography>
        {tooltip && (
          <Tooltip arrow title={tooltip} placement="top" maxWidth="370px">
            <InfoIcon className="icon-info" />
          </Tooltip>
        )}
      </Box>
      <Box>
        <Typography variant="body-14-medium" color={colorValue}>
          {isDeduction && '-'}
          {renderUnit(colorValue)}
          {value}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box className="tax-deduction-container">
      {isError && (
        <Typography
          variant="body-14-regular"
          color={COLOR.functionalRed.default}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              t(helperText || 'amountMin', {
                minAmount: getPriceText(
                  MINIMUM_VOICE_REVENUE_WITHDRAWAL_AMOUNT,
                  true,
                  language,
                ),
              }),
              {
                allowedTags: ['span'],
                allowedAttributes: {
                  span: ['style'],
                },
              },
            ),
          }}
        />
      )}
      {isShowTaxDeduction && (
        <Box className="tax-deduction-box">
          {renderItem({
            label: t('amountToWithdraw'),
            value: amountToWithdraw?.toLocaleString(language),
            colorValue: COLOR.black.default,
          })}
          {renderItem({
            label: t('taxDeduction'),
            value: taxDeduction?.toLocaleString(language),
            tooltip: t('taxDeductionDesc'),
            colorValue: COLOR.functionalRed.default,
            isDeduction: true,
          })}
          <Divider />
          {renderItem({
            label: t('amountReceivedAfterTax'),
            value: amountReceivedAfterTax?.toLocaleString(language),
            colorLabel: COLOR.black.default,
            colorValue: COLOR.green,
          })}
        </Box>
      )}
    </Box>
  );
};

export default TaxDeduction;
